// Local tenant/store configuration for unauthenticated users
// This file is gitignored (.gitignore) so you can safely change it per environment.
// Default path to use ONLY for unauthenticated users:

export const DEFAULT_UNAUTH_TENANT_PATH = "tenants/1234/stores/999";


